
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

const UL = styled.ul`
    list-style: disc;
`;
const OL = styled.ol`
    list-style: auto ;
`;
const StyledListItem = styled.li`
    ${props => props.theme.typography.body1};
    color: ${p => p.theme.palette.text.primary};
    margin-left: ${props => props.theme.spacing(3)} ;
`;

export const BulletedList: React.FC<RenderElementProps> = (props) => {
    return <UL {...props.attributes}>
        {props.children}
    </UL>
}
export const NumberedList: React.FC<RenderElementProps> = (props) => {
    return <OL {...props.attributes}>
        {props.children}
    </OL>
}
export const ListItem: React.FC<RenderElementProps> = (props) => {
    return <StyledListItem {...props.attributes}>
        {props.children}
    </StyledListItem>
}